/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `Projects` - PROJECTS
 * * `Agents` - AGENTS
 * * `Build` - BUILD
 * * `Chats` - CHATS
 */
export enum ViewMode {
  PROJECTS = 'Projects',
  AGENTS = 'Agents',
  BUILD = 'Build',
  CHATS = 'Chats',
}
